import { BaseEntity } from "./base-entity";

export class ButtonMedia extends BaseEntity{
    constructor(){
        super();
    }

    MediaInfoId: string = null;
    LabelaTastera: string = null;
    LinkTastera: string = null;
    GenericName: string = null;
    OpisTastera: string = null;


    Deserialize(input: any): this {
        this.ID = input.ID;
        this.MediaInfoId = input.MediaInfoId;
        this.LabelaTastera = input.LabelaTastera;
        this.LinkTastera = input.LinkTastera;
        this.GenericName = input.GenericName;
        this.OpisTastera = input.OpisTastera;

        return this;
    }
}